"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconGlobe = function IconGlobe(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 12 12",
    className: (0, _classnames.default)('Icon', 'IconGlobe', className),
    style: style
  }, _react.default.createElement("g", {
    id: "New",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "[ILT]-Pre-req-not-available-in-subaccount---Popup",
    transform: "translate(-558.000000, -392.000000)"
  }, _react.default.createElement("g", {
    id: "Overlay---Details",
    transform: "translate(520.000000, 302.000000)"
  }, _react.default.createElement("g", {
    id: "Group-9",
    transform: "translate(38.000000, 88.000000)"
  }, _react.default.createElement("g", {
    id: "icon-globe-copy-3",
    transform: "translate(0.000000, 2.000000)"
  }, _react.default.createElement("path", {
    d: "M6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 Z M3.30171429,6.54514286 L1.12114286,6.54514286 C1.34741442,8.56472778 2.79371692,10.2365785 4.75971429,10.7511429 C3.92553826,9.4951535 3.42386946,8.04795257 3.30171429,6.54514286 L3.30171429,6.54514286 Z M10.8788571,6.54514286 L8.7,6.54514286 C8.57811154,8.04787464 8.07609543,9.49493166 7.24114286,10.7502857 C9.20653902,10.2360791 10.6525093,8.56489999 10.8788571,6.546 L10.8788571,6.54514286 Z M7.60628571,6.54514286 L4.39542857,6.54514286 C4.53224942,8.02491025 5.0889482,9.43479748 6,10.6088571 C6.91180818,9.43539943 7.46913505,8.02572527 7.60628571,6.546 L7.60628571,6.54514286 Z M4.75885714,1.25057143 L4.72457143,1.25914286 C2.77555246,1.78465809 1.34630236,3.44883013 1.12114286,5.45485714 L3.3,5.45485714 C3.42203107,3.95242118 3.92404127,2.50567615 4.75885714,1.25057143 Z M6,1.39114286 C5.08819182,2.56460057 4.53086495,3.97427473 4.39371429,5.454 L7.60457143,5.454 C7.46759121,3.97453103 6.91090073,2.56496221 6,1.39114286 L6,1.39114286 Z M7.24028571,1.24885714 L7.29514286,1.332 C8.09672561,2.56904656 8.57884395,3.98565574 8.69828571,5.45485714 L10.8788571,5.45485714 C10.6525856,3.43527222 9.20628308,1.76342148 7.24028571,1.24885714 L7.24028571,1.24885714 Z",
    id: "a"
  })))))));
};

var _default = IconGlobe;
exports.default = _default;